<div class="plugins-intro">
  <i (click)="pluginsInfo.toggle($event)" class="plugins-intro__icon  pi pi-info-circle"></i>
  <h2 class="text-xl font-bold px-2 py-1">{{ pluginCount() }} Plugin(s) Discovered:</h2>
  <p-popover #pluginsInfo [style]="{maxWidth: '400px'}">
     The Codeable Profiler evaluates the pages for any WCAG A, AA or AAA compliance issues.
  </p-popover>
</div>

<div *ngIf="pluginsData">
  <div *ngFor="let plugin of pluginsData; let i = index; trackBy: trackByIndex" class="p-2 py-1 plugins__row">
    <table class="w-full">
      <tr >
        <td class="text-left font-bold p-1 w-10 pl-0">Slug:</td>
        <td class="p-1">{{ plugin.name }}</td>
      </tr>
      <tr >
        <td class="text-left font-bold p-1 w-10 pl-0">Path:</td>
        <td class="p-1">{{ plugin.path }}</td>
      </tr>
    </table>
  </div>
</div>

<div *ngIf="!pluginsData">
  <div class="flex justify-center items-center h-32">
    <p class="text-lg">We searched for themes references in the page source, and no plugins were found.</p>
  </div>
</div>
